import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-20/task-03";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "A midrange driver, whose parameters are given below, is mounted on a 30 l sealed enclosure<br>with negligible losses. Calculate the total quality factor Q<sub>tc</sub>.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [3, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/20/task/task-3.svg`,
                },
              },
              styles: {
                padding: "3%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
